"use client";
import styles from "./OutletSideDrawer.module.scss";
import { Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/Drawer";
import { ListItem } from "@/components/__shared__/ListItem/ListItem.tsx";
import { ArrowRightOutlined as ArrowRight } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ArrowRightOutlined";
import { useState } from "react";
import { withSideDrawerAnalytics } from "@/components/ProductSideDrawers/withSideDrawerAnalytics.tsx";

export function OutletSideDrawerUI() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <ListItem
        label="Outlet"
        onClick={withSideDrawerAnalytics("Outlet", () => setOpen(true))}
        trailingIcon={<ArrowRight size="medium" />}
        data-testid="drawer:outlet"
      />
      <Drawer
        isOpen={open}
        onClose={() => setOpen(false)}
        heading="Outlet"
        primaryButtonText="Close"
      >
        <div className={styles.outlet} data-testid="product:outlet">
          <span className={styles.heading}>
            Good as new returned items with up to 30% off
          </span>
          <p>
            Everything in our Outlet has been thoroughly checked by our expert
            Partners to make sure they meet our quality standards. They can be
            returned within 30 days and have the same guarantees as our new,
            full price items.
          </p>
          <span className={styles.heading}>Certified: Like new</span>
          <p>
            Meaning perfect condition, no bumps, scratches or marks. Usually
            only the box has been opened, or the item&apos;s been repackaged.
          </p>
        </div>
      </Drawer>
    </>
  );
}
